import { render, staticRenderFns } from "./CollapsibleCardBase.vue?vue&type=template&id=6a6a4a59&scoped=true&"
import script from "./CollapsibleCardBase.vue?vue&type=script&lang=js&"
export * from "./CollapsibleCardBase.vue?vue&type=script&lang=js&"
import style0 from "./CollapsibleCardBase.vue?vue&type=style&index=0&id=6a6a4a59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6a4a59",
  null
  
)

export default component.exports